var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1377 11.3438C2.1377 10.971 2.4399 10.6687 2.8127 10.6687H21.1877C21.5605 10.6687 21.8627 10.971 21.8627 11.3438C21.8627 11.7165 21.5605 12.0188 21.1877 12.0188H2.8127C2.4399 12.0188 2.1377 11.7165 2.1377 11.3438Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5939 15.9188C16.9667 15.9188 17.2689 16.221 17.2689 16.5938V18.5437H19.2002V16.5938C19.2002 16.221 19.5024 15.9188 19.8752 15.9188C20.248 15.9188 20.5502 16.221 20.5502 16.5938V18.5625C20.5502 18.9156 20.4099 19.2542 20.1603 19.5038C19.9106 19.7535 19.572 19.8937 19.2189 19.8937H17.2502C16.8971 19.8937 16.5585 19.7535 16.3089 19.5038C16.0592 19.2542 15.9189 18.9156 15.9189 18.5625V16.5938C15.9189 16.221 16.2212 15.9188 16.5939 15.9188Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1252 15.9188C4.49799 15.9188 4.8002 16.221 4.8002 16.5938V18.5437H6.73145V16.5938C6.73145 16.221 7.03365 15.9188 7.40645 15.9188C7.77924 15.9188 8.08145 16.221 8.08145 16.5938V18.5625C8.08145 18.9156 7.94119 19.2542 7.69153 19.5038C7.44187 19.7535 7.10326 19.8937 6.7502 19.8937H4.78145C4.42838 19.8937 4.08977 19.7535 3.84011 19.5038C3.59045 19.2542 3.4502 18.9156 3.4502 18.5625V16.5938C3.4502 16.221 3.7524 15.9188 4.1252 15.9188Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0752 13.9687C6.0752 13.596 6.3774 13.2937 6.7502 13.2937H8.0627C8.43549 13.2937 8.7377 13.596 8.7377 13.9687C8.7377 14.3415 8.43549 14.6437 8.0627 14.6437H6.7502C6.3774 14.6437 6.0752 14.3415 6.0752 13.9687Z",
    fill: "#383733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2627 13.9687C15.2627 13.596 15.5649 13.2937 15.9377 13.2937H17.2502C17.623 13.2937 17.9252 13.596 17.9252 13.9687C17.9252 14.3415 17.623 14.6437 17.2502 14.6437H15.9377C15.5649 14.6437 15.2627 14.3415 15.2627 13.9687Z",
    fill: "#383733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45126 4.97751C6.66718 4.83719 6.91916 4.7625 7.17668 4.7625H16.8237C17.0812 4.7625 17.3332 4.83718 17.5491 4.97751C17.7651 5.11783 17.9356 5.31776 18.0402 5.55308L20.492 11.0696C20.5304 11.1559 20.5502 11.2493 20.5502 11.3437V16.5937C20.5502 16.9665 20.248 17.2687 19.8752 17.2687H4.1252C3.7524 17.2687 3.4502 16.9665 3.4502 16.5937V11.3437C3.4502 11.2493 3.47001 11.1559 3.50837 11.0696L5.96016 5.55308C6.06475 5.31776 6.23534 5.11783 6.45126 4.97751ZM7.18886 6.1125L4.8002 11.487V15.9187H19.2002V11.487L16.8115 6.1125H7.18886Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.bcfe1f429805af8a265be03defcaa32a.svg";
export { ForwardRef as ReactComponent };